import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { userService } from './services/user.services';
import { userConstants } from './constants/user.constants';

export default function AppInitializer() {
  const dispatch = useDispatch();

  useEffect(() => {
    userService.getMe()
      .then((user) => {
        if (user) {
          dispatch({ type: userConstants.SET_CURRENT_USER, user });
        } else {
          dispatch({ type: userConstants.AUTH_INITIALIZED });
        }
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 401) {
          dispatch({ type: userConstants.AUTH_INITIALIZED });
        } else {
          // CORS / network error — can't confirm session state, keep user in
          dispatch({ type: userConstants.SET_CURRENT_USER, user: {} });
        }
      });
  }, [dispatch]);

  return null;
}
